export const QUERY_KEY = {
  COMPANY_LIST: "companyList",
  INFINITE_COMPANY_LIST: "infiniteCompanyList",
  MY_INFO: "myInfo",
};
